import { defineStore } from "pinia";

// Pretraga sajta: /api/search/suggest (padajuca lista u zaglavlju) i /api/search (stranica rezultata)
export const useSearchStore = defineStore("searchStore", () => {

    // scope: null = ceo sajt, 'oglasi' = samo oglasi
    async function suggest(q, scope = null) {
      try {
        const { data } = await useNuxtApp().$apiAxios.get(`/api/search/suggest`, {
          params: { q, scope: scope || undefined }
        })

        return {
          success: data?.success,
          data: data?.data,
        };

      } catch (error) {

        return {
          success: false,
          status: error.response?.status,
          data: null,
        };
      }
    }

    async function search(params) {
      try {
        const { data } = await useNuxtApp().$apiAxios.get(`/api/search`, {
          params: { ...params }
        })

        return {
          success: data?.success,
          data: data?.data,
        };

      } catch (error) {

        return {
          success: false,
          status: error.response?.status,
          data: null,
        };
      }
    }

    // beleska za statistiku: korisnik je izabrao rezultat iz padajuce liste.
    // fetch sa keepalive: zahtev se zavrsava i ako se stranica menja; greska ne sme da smeta navigaciji.
    // (putanja nema reci kao sto je 'click', koje blokatori reklama cesto sprecavaju)
    // from: 'list' (padajuca lista) ili 'page' (stranica rezultata)
    async function click(q, path, from = 'list', scope = null) {
      try {
        const base = useRuntimeConfig().public.API_BASE_URL_WEB

        await fetch(`${base}/api/search/choice`, {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ q, path, from, scope: scope || undefined }),
        })
      } catch (error) {
        // namerno ignorisano
      }
    }

    return {
      suggest,
      search,
      click
    }
})
